<template>
  <g>
    <path
      d="M21 6.30018C21 5.51018 20.53 4.79018 19.81 4.47018L12.81 1.36018C12.29 1.13018 11.7 1.13018 11.19 1.36018L4.19 4.47018C3.47 4.79018 3 5.51018 3 6.30018V11.0002C3 16.5502 6.84 21.7402 12 23.0002C14.3 22.4402 16.33 21.1002 17.88 19.2902L14.76 16.1702C12.82 17.4602 10.18 17.2402 8.47 15.5302C6.52 13.5802 6.52 10.4102 8.47 8.46018C10.42 6.51018 13.59 6.51018 15.54 8.46018C17.25 10.1702 17.46 12.8102 16.18 14.7502L19.08 17.6502C20.29 15.6902 21 13.3802 21 11.0002V6.30018Z"
    />
    <path
      d="M12 15.0002C13.6569 15.0002 15 13.657 15 12.0002C15 10.3433 13.6569 9.00018 12 9.00018C10.3431 9.00018 9 10.3433 9 12.0002C9 13.657 10.3431 15.0002 12 15.0002Z"
    />
  </g>
</template>
